import React from 'react';
import './PaymentFlowStatus.css';

const StatusIcon = ({ variant }) => {
  if (variant === 'processing') {
    return <span className="payflow-spinner" aria-hidden="true" />;
  }

  if (variant === 'success') {
    return (
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M20 6L9 17L4 12"
          stroke="currentColor"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (variant === 'pending') {
    return (
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="2" />
        <path
          d="M12 7.5V12L15 14"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
    </svg>
  );
};

/**
 * 결제 리다이렉트 과정의 처리 중·실패·대기·완료 화면을 한 가지 문법으로 보여준다.
 * 결제 API/상태 로직은 각 페이지에 두고, 이 컴포넌트는 표시만 담당한다.
 */
const PaymentFlowStatus = ({
  variant = 'processing',
  title,
  description,
  detailCode,
  primaryAction,
  secondaryAction,
  footer,
}) => {
  const isAlert = variant === 'error';

  return (
    <main className="payflow-page">
      <section
        className={`payflow-card payflow-card--${variant}`}
        aria-labelledby="payflow-title"
        aria-live={variant === 'processing' || variant === 'pending' ? 'polite' : undefined}
        role={isAlert ? 'alert' : variant === 'processing' ? 'status' : undefined}
      >
        <div className={`payflow-icon payflow-icon--${variant}`}>
          <StatusIcon variant={variant} />
        </div>

        <h1 id="payflow-title" className="payflow-title">
          {title}
        </h1>
        {description && <p className="payflow-description">{description}</p>}

        {variant === 'processing' && (
          <div className="payflow-progress" aria-hidden="true">
            <span className="payflow-progress-bar" />
          </div>
        )}

        {detailCode && (
          <details className="payflow-details">
            <summary>오류 정보 보기</summary>
            <code>{detailCode}</code>
          </details>
        )}

        {(primaryAction || secondaryAction) && (
          <div className="payflow-actions">
            {primaryAction && (
              <button
                type="button"
                className="payflow-button payflow-button--primary"
                onClick={primaryAction.onClick}
              >
                {primaryAction.label}
              </button>
            )}
            {secondaryAction && (
              <button
                type="button"
                className="payflow-button payflow-button--secondary"
                onClick={secondaryAction.onClick}
              >
                {secondaryAction.label}
              </button>
            )}
          </div>
        )}

        {footer && <div className="payflow-footer">{footer}</div>}
      </section>
    </main>
  );
};

export default PaymentFlowStatus;
